import { Component, forwardRef, Input, OnInit, TemplateRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { subYears, addYears, setQuarter, startOfYear, endOfQuarter, isSameQuarter, differenceInDays } from "date-fns";

export const RANGE_QUARTER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangeQuarterComponent),
  multi: true,
};

@Component({
  selector: "host-range-quarter",
  templateUrl: "./range-quarter.component.html",
  styleUrls: ["./range-quarter.component.scss"],
  providers: [RANGE_QUARTER_VALUE_ACCESSOR],
})
export class RangeQuarterComponent implements OnInit, ControlValueAccessor {
  @Input() extraFooter?: TemplateRef<void>;

  // readonly listOfQuarter = [

  // ];
  years: Date[] = [new Date(), addYears(new Date(), 1)];

  listOfQuarter = [];

  value: Date[];

  _registerOnChange: (value: any) => void = (r: any) => {};

  constructor() {}

  ngOnInit() {
    this.updateListOfQuarter();
  }

  private updateListOfQuarter() {
    this.listOfQuarter = this.years.map((_year) => {
      const year = startOfYear(_year);
      return [
        { label: "component.search.first_quarter", value: setQuarter(year, 1) },
        { label: "component.search.second_quarter", value: setQuarter(year, 2) },
        { label: "component.search.third_quarter", value: setQuarter(year, 3) },
        { label: "component.search.fourth_quarter", value: setQuarter(year, 4) },
      ];
    });
  }

  isSelected(date: Date) {
    if (!this.value) {
      return false;
    }
    if (this.value.find((quarter) => isSameQuarter(quarter, date))) {
      return true;
    }
  }

  onChangeYears(dir: "next" | "prev") {
    this.years = this.years.map((year) => (dir === "next" ? addYears(year, 1) : subYears(year, 1)));
    this.updateListOfQuarter();
  }

  onClickQuarter(value: Date) {
    if (!this.value || this.value.length === 2) {
      // 当前值为空或者为2，则重置
      this.value = [value];
    } else if (this.value.length === 1) {
      if (value === this.value[0]) {
        // 一个格子点击两次，则需要将第二次的数据置为季度的最后一天
        value = endOfQuarter(value);
      }
      const values = [...this.value, value];
      values.sort((a, b) => differenceInDays(a, b));
      // 将第二个日期置为季度的最后一天
      this.value = [values[0], endOfQuarter(values[1])];
    }

    if (!this.value || this.value.length === 2) {
      this._registerOnChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: Date[]): void {
    console.log("write value: ", value);

    this.value = value;
  }
}
